import {ReactionSystem} from "tick-knock";
import {Spawner} from "@game/coregame/view/Spawner";
import {FighterGroupsSystem} from "@game/coregame/ecs/systems/FighterGroupSystem";

export class LevelEndSystem extends ReactionSystem {
    constructor() {
        super(e => e.has(Spawner));
        FighterGroupsSystem.Clear();
    }

    update() {
        this.entities.forEach(entity => entity.get<Spawner>(Spawner)?.stopRoutine());
        this.engine.removeSystem(this);
    }
}
